import React, { createContext, useContext, useState } from "react";

// Create Context
const RefreshContext = createContext();

// Provide Context (Wrap the app)
export const RefreshProvider = ({ children }) => {
    const [refreshTrigger, setRefreshTrigger] = useState(0); // This will trigger refresh when changed

    // Function to trigger a refresh
    const refreshPFdata = () => {
        setRefreshTrigger(prev => prev + 1); // Increment to notify all subscribers
    };

    return (
        <RefreshContext.Provider value={{ refreshPFdata, refreshTrigger }}>
            {children}
        </RefreshContext.Provider>
    );
};

// Hook to use in any component
export const useRefreshContext = () => useContext(RefreshContext);
